var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-row flex-1" }, [
    _c("div", { staticClass: "flex-col flex-1" }, [
      _vm.criteriaModel
        ? _c("div", { staticClass: "flex-row flex-1 pt-1 pb-1" }, [
            _c("div", { staticClass: "flex-col checkbox mr-2" }, [
              _c("div", {
                staticClass: "satisfaction-box",
                class: { green: _vm.criteriaModel.isSatisfied },
              }),
            ]),
            _c(
              "div",
              { staticClass: "flex-col flex-1" },
              [
                _vm._v(_vm._s(_vm.criteriaModel.uiText) + " "),
                _vm._l(
                  _vm.criteriaModel.params,
                  function (decision, decisionIndex) {
                    return _c(
                      "div",
                      { key: decisionIndex, staticClass: "flex-row flex-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex-row flex-1 pl-4 pt-1 pb-1" },
                          [
                            _vm._v(
                              _vm._s(decision.uiText) +
                                " : " +
                                _vm._s(decision.value)
                            ),
                          ]
                        ),
                      ]
                    )
                  }
                ),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }